import React from "react";
import { Link } from "react-router-dom";

const CTA = () => {
  return (
    <section className="relative py-20 bg-gradient-to-r from-purple-600 to-blue-600 text-white overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-10"></div>
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold mb-6">
          Ready to revolutionize your customer communication?
        </h2>
        <p className="text-xl mb-10 opacity-90">
          Join thousands of businesses already using ConvoHub to deliver
          exceptional customer experiences
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Link to={'/create-account'} className="bg-white text-purple-600 px-8 py-4 rounded-lg hover:bg-gray-50 transition-colors font-medium flex items-center space-x-2">
            <span>Start Free Trial</span>
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
          {/* <button className="border border-white text-white px-8 py-4 rounded-lg hover:bg-white hover:bg-opacity-10 transition-colors">
            Schedule Demo
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default CTA;
